
<template lang="pug">
  a.button.button--primary(
    :href="checkoutURL"
    :disabled="isDisabled || redirectInProgress"
    @click.prevent="redirectToCheckout"
  )
    span {{ label }}
</template>

<script>
  import { mapState } from 'vuex';
  import { getRechargeURL } from 'scripts/helpers/recharge.js';

  import Icon from 'scripts/components/basic/Icon.vue';
  import PrimaryButton from 'scripts/components/buttons/PrimaryButton.vue';

  export default {
    extends: PrimaryButton,
    components: { Icon },
    name: 'CheckoutButton',
    data () {
      return {
        redirectInProgress: false,
      }
    },
    computed: {
      ...mapState({
        items: state => state.cart.checkout.items,
        permanentDomain: state => state.storefront.permanentDomain,
        customer: state => state.storefront.customer,
        rechargeGwpCode: state => state.storefront.rechargeGwpCode,
        employeeDiscountCode: state => state.storefront.employeeDiscountCode,
        employeeEmailDomains: state => state.storefront.employeeEmailDomains,
      }),
      hasSubscriptionProducts () {
        if (!this.items) return false;
        // Check for selling plan allocations (modern subscriptions)
        return !!this.items.find((product) => product.selling_plan_allocation);
      },
      checkoutURL () {
        // Recharge checkout deprecated Oct 2024 - always use Shopify checkout
        const discountCode = (this.customerIsEmployee) ? this.employeeDiscountCode : this.rechargeGwpCode;
        return discountCode ? `/checkout?discount=${discountCode}` : '/checkout';
      },
      userIsLoggedIn () {
        return Boolean(this.customer && this.customer.email);
      },
      customerEmailDomain () {
        return this.userIsLoggedIn ? this.customer.email.substring(this.customer.email.indexOf('@') + 1) : null;
      },
      customerIsEmployee () {
        return this.customerEmailDomain ? this.employeeEmailDomains.includes(this.customerEmailDomain) : false;
      },
    },
    methods: {
      async redirectToCheckout () {
        this.redirectInProgress = true;

        if (!this.hasSubscriptionProducts && this.customerIsEmployee) {
          await fetch(`/discount/${this.employeeDiscountCode}`);
        }

        window.location.href = this.checkoutURL;
      },
    },
  };
</script>

<style scoped lang="scss">
</style>
